import { useEffect, useState } from "react";
import { Accordion, Card, Table, Button, Row, Col, Form } from "react-bootstrap";
import { api } from "../services/api";
import { Provincia, Canton, Parroquia } from "../types/Catalogos";
import { Contact } from "../types/Contact";

interface ContactosSeleccionadosResponse {
  items: Contact[];
  total: number;
  limit: number;
}

export default function ContactsSelectedPage() {
  const [selProv, setSelProv] = useState("");
  const [selCanton, setSelCanton] = useState("");
  const [selParroquia, setSelParroquia] = useState("");
  const [selSexo, setSelSexo] = useState<string[]>([]);
  const [selSueldoMin, setSelSueldoMin] = useState<number | "">("");
  const [selSueldoMax, setSelSueldoMax] = useState<number | "">("");
  const [selLimit, setSelLimit] = useState(10);

  const [provincias, setProvincias] = useState<Provincia[]>([]);
  const [cantones, setCantones] = useState<{ codcanton: string; nomcanton: string }[]>([]);
  const [parroquiasSel, setParroquiasSel] = useState<{ codparroquia: string; nomparroquia: string }[]>([]);

  const [contactosSel, setContactosSel] = useState<any[]>([]);
  const [loadingSel, setLoadingSel] = useState(false);

  useEffect(() => {
    api
      .get<Provincia[]>("/catalogos/provincias")
      .then((r) => setProvincias(r.data || []))
      .catch(() => setProvincias([]));
  }, []);

  useEffect(() => {
    if (!selProv) {
      setCantones([]);
      setSelCanton("");
      setParroquiasSel([]);
      setSelParroquia("");
      return;
    }

    api
      .get<Canton[]>("/catalogos/cantones", { params: { codprov: selProv } })
      .then((r) => setCantones(r.data || []))
      .catch(() => setCantones([]));
  }, [selProv]);

  useEffect(() => {
    if (!selCanton) {
      setParroquiasSel([]);
      setSelParroquia("");
      return;
    }

    api
      .get<Parroquia[]>("/catalogos/parroquias", { params: { codcanton: selCanton } })
      .then((r) => setParroquiasSel(r.data || []))
      .catch(() => setParroquiasSel([]));
  }, [selCanton]);

  const buscarContactosAleatorios = async () => {
    if (!selProv) {
      alert("Selecciona al menos una provincia");
      return;
    }

    setLoadingSel(true);
    try {
      const params: Record<string, string | number> = {
        limit: selLimit,
        codprov: selProv,
      };

      if (selCanton) params.codcanton = selCanton;
      if (selParroquia) params.codparroquia = selParroquia;
      if (selSueldoMin !== "") params.sueldo_min = selSueldoMin;
      if (selSueldoMax !== "") params.sueldo_max = selSueldoMax;
      if (selSexo.length === 1) params.sexo = selSexo[0];

      const res = await api.get<ContactosSeleccionadosResponse>("/contactos/seleccionar-contactos", { params });
      setContactosSel(res.data.items || []);
      console.log(res.data);
    } catch (error: any) {
      console.error(error);
      alert(error.response?.data?.detail || "Error al buscar contactos");
      setContactosSel([]);
    } finally {
      setLoadingSel(false);
    }
  };

  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div>
      <h2 className="mb-4">Seleccionar contactos</h2>

        <Card className="mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
                <div>
                    <strong>Contactos</strong>
                </div>
            </Card.Header>

            <div style={{ display: "flex", width: "100%" }}>
                {sidebarOpen && (
                    <div style={{
                        width: "280px",           // un poco más ancho para los nuevos filtros
                        padding: "10px",
                        borderRight: "1px solid #ddd",
                        background: "#fafafa",
                        overflowY: "auto",
                        maxHeight: "650px"
                    }}>
                        <Accordion defaultActiveKey="sel-contactos">
                            <Accordion.Item eventKey="sel-contactos">
                            <Accordion.Header>Filtros</Accordion.Header>
                            <Accordion.Body>
                                <Form.Group className="mb-2">
                                <Form.Label className="small">Provincia</Form.Label>
                                <Form.Select
                                    value={selProv}
                                    onChange={(e) => setSelProv(e.target.value)}
                                >
                                    <option value="">Seleccione...</option>
                                    {provincias.map((p) => (
                                    <option key={p.codprov} value={p.codprov}>
                                        {p.nomprov}
                                    </option>
                                    ))}
                                </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                <Form.Label className="small">Cantón</Form.Label>
                                <Form.Select
                                    value={selCanton}
                                    onChange={(e) => setSelCanton(e.target.value)}
                                    disabled={!selProv}
                                >
                                    <option value="">Todos</option>
                                    {cantones.map((c) => (
                                    <option key={c.codcanton} value={c.codcanton}>
                                        {c.nomcanton}
                                    </option>
                                    ))}
                                </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                <Form.Label className="small">Parroquia</Form.Label>
                                <Form.Select
                                    value={selParroquia}
                                    onChange={(e) => setSelParroquia(e.target.value)}
                                    disabled={!selCanton}
                                >
                                    <option value="">Todas</option>
                                    {parroquiasSel.map((p) => (
                                    <option key={p.codparroquia} value={p.codparroquia}>
                                        {p.nomparroquia}
                                    </option>
                                    ))}
                                </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                <Form.Label className="small">Sexo</Form.Label>
                                {["M", "F"].map((s) => (
                                    <Form.Check
                                    key={s}
                                    type="checkbox"
                                    label={s === "M" ? "Masculino" : "Femenino"}
                                    checked={selSexo.includes(s)}
                                    onChange={() =>
                                        setSelSexo((prev) =>
                                        prev.includes(s)
                                            ? prev.filter((x) => x !== s)
                                            : [...prev, s]
                                        )
                                    }
                                    />
                                ))}
                                </Form.Group>

                                <Row className="g-2 mb-2">
                                <Col xs={6}>
                                    <Form.Label className="small">Sueldo min</Form.Label>
                                    <Form.Control
                                    type="number"
                                    value={selSueldoMin}
                                    onChange={(e) =>
                                        setSelSueldoMin(e.target.value ? Number(e.target.value) : "")
                                    }
                                    />
                                </Col>
                                <Col xs={6}>
                                    <Form.Label className="small">Sueldo max</Form.Label>
                                    <Form.Control
                                    type="number"
                                    value={selSueldoMax}
                                    onChange={(e) =>
                                        setSelSueldoMax(e.target.value ? Number(e.target.value) : "")
                                    }
                                    />
                                </Col>
                                </Row>

                                {/*
                                <Form.Group className="mb-3">
                                <Form.Label className="small">Tope de contactos</Form.Label>
                                <Form.Control
                                    type="number"
                                    min={1}
                                    max={100}
                                    value={selLimit}
                                    onChange={(e) => setSelLimit(Number(e.target.value) || 10)}
                                />
                                </Form.Group>
                                */}

                                <Button
                                variant="primary"
                                size="sm"
                                className="w-100"
                                disabled={loadingSel}
                                onClick={buscarContactosAleatorios}
                                >
                                {loadingSel ? "Buscando..." : "Buscar aleatorios"}
                                </Button>
                            </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </div>
                )}

                <div style={{ flex: 1 }}>
                    <Card className="mb-4">
                        <Card.Header>
                        <strong>Contactos seleccionados</strong>
                        {contactosSel.length > 0 && (
                            <span className="ms-2 text-muted">({contactosSel.length})</span>
                        )}
                        </Card.Header>

                        {loadingSel && <div className="text-center py-3">Cargando...</div>}

                        {!loadingSel && contactosSel.length === 0 && (
                        <div className="text-center py-3 text-muted">
                            Usa los filtros y pulsa “Buscar aleatorios”
                        </div>
                        )}

                        {!loadingSel && contactosSel.length > 0 && (
                        <Table striped bordered hover size="sm">
                            <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Teléfono</th>
                                <th>Dirección</th>
                                <th>Ocupación</th>
                            </tr>
                            </thead>
                            <tbody>
                            {contactosSel.map((c) => (
                                <tr key={c.id}>
                                <td>{c.nombre}</td>
                                <td>{c.telefono}</td>
                                <td>{c.direccion}</td>
                                <td>{c.ocupacion}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                        )}
                    </Card>                
                </div>                
            </div>
        </Card>

      <Row>
        <Col md={4} lg={3} className="mb-4">

        </Col>

        <Col md={8} lg={9}>
        </Col>
      </Row>
    </div>
  );
}